import React from "react"
import classNames from "classnames"
import OtpCodeInput from "../OtpCodeInput/OtpCodeInput"
import styles from "./EmailMfaOtpChallenge.module.scss"

const EmailIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
    <path
      fill="currentColor"
      d="M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4-8 5-8-5V6l8 5 8-5v2z"
    />
  </svg>
)

const EyeIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
    <path
      fill="currentColor"
      d="M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
    />
  </svg>
)

const RefreshIcon = () => (
  <svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true">
    <path
      fill="currentColor"
      d="M17.65 6.35A7.95 7.95 0 0 0 12 4a8 8 0 1 0 7.75 10h-2.1A6 6 0 1 1 12 6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
    />
  </svg>
)

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
    <path
      fill="currentColor"
      d="M17 1.01 7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
    />
  </svg>
)

const heroIconForMode = (mode) => {
  if (mode === "view") return <EyeIcon />
  if (mode === "regenerate") return <RefreshIcon />
  return <EmailIcon />
}

const EmailMfaOtpChallenge = ({
  title,
  description = "Enter the 6-digit code we sent to your email to confirm this change.",
  otp,
  onOtpChange,
  error,
  busy = false,
  onCancel,
  onConfirm,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
  variant = "panel",
  mode,
  otpInputRef,
  onSendSms,
  smsBusy = false,
  smsMessage = "",
}) => {
  const isModal = variant === "modal"
  const showSmsBackup = typeof onSendSms === "function"

  return (
    <div
      className={classNames(
        styles.challenge,
        isModal ? styles.modalPanel : styles.panel,
      )}
    >
      {isModal && (
        <div className={styles.hero} aria-hidden="true">
          <span className={styles.heroIcon}>{heroIconForMode(mode)}</span>
        </div>
      )}

      <div className={styles.header}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.text}>{description}</p>
      </div>

      <OtpCodeInput
        ref={otpInputRef}
        name="mfa_otp"
        value={otp}
        onChange={(e) => onOtpChange(e.target.value)}
        error={!!error}
        errorMessage={error}
        disabled={busy}
        autoFocus
        theme={isModal ? "light" : "dark"}
      />

      {showSmsBackup && (
        <div className={styles.smsBackup}>
          <button
            type="button"
            className={classNames(styles.smsLink, smsBusy && styles.smsSending)}
            onClick={onSendSms}
            disabled={busy || smsBusy}
            aria-busy={smsBusy}
          >
            <PhoneIcon />
            <span>
              {smsBusy
                ? "Sending text to your phone..."
                : "Didn't get the email? Send code by SMS"}
            </span>
          </button>
          {(smsBusy || smsMessage) && (
            <p className={styles.smsMessage}>
              {smsBusy && !smsMessage
                ? "Please wait — we're texting your verification code."
                : smsMessage}
            </p>
          )}
        </div>
      )}

      <div className={styles.actions}>
        <button
          type="button"
          className={styles.cancelBtn}
          onClick={onCancel}
          disabled={busy}
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          className={styles.confirmBtn}
          disabled={busy || String(otp || "").length !== 6}
          onClick={onConfirm}
        >
          {busy ? "Verifying..." : confirmLabel}
        </button>
      </div>
    </div>
  )
}

export default EmailMfaOtpChallenge
